module.exports = __webpack_public_path__ + "img/weAreMafsi-150.85bcd893.png";